import { config } from '../config';
import { addAuthHeader } from './auth';
import logger from "#/utils/logger";
import { Feature, FeatureRecord } from '#/types/message';

export async function sendFeatureSelections(
  selections: { feature_name: string, option_name: string }[]) {
  const response = await fetch(
    `${config.backendUrl}/feature`,
    {
      method: 'POST',
      headers: await addAuthHeader({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        'selections': selections
      })
    })
  const data: FeatureRecord = await response.json();
  return data;
}

export async function getFeature(featureName: string): Promise<Feature> {
  try {
    const response = await fetch(
      `${config.backendUrl}/feature/${featureName}`,
      {
        method: 'GET',
        headers: await addAuthHeader({ 'Content-Type': 'application/json' })
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch feature details: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    logger.error('Error fetching feature details:', error);
    throw error;
  }
}

export async function clearFeature(featureName: string) {
  // Reset the feature to the null state
  try {
    const response = await fetch(
      `${config.backendUrl}/feature/${featureName}`,
      {
      method: 'DELETE',
      headers: await addAuthHeader({ 'Content-Type': 'application/json' })
    }
  );
  if (!response.ok) {
      throw new Error(`Failed to reset feature: ${response.statusText}`);
    }
    return response.json();
  } catch (error) {
    logger.error('Error resetting feature:', error);
    throw error;
  }
}